import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map, shareReplay } from 'rxjs';
import { environment } from 'src/environments/environment';
import { LongevityAlertsService } from '../../../alerts/longevity-alerts/longevity-alerts.service';
import {
  LongevityAssessmentDetail,
  LongevityAssessmentUpdate,
  LongevityTestRow,
} from '../../../alerts/longevity-alerts/longevity-alerts.model';
import { normalizeQuestionnaire } from './longevity-request-assessments.mapper';
import { LongevityQuestionnaireDef } from './longevity-request-assessments.model';

/**
 * Test Longevity di UNA richiesta, lato operatore. Il backend non ha più un endpoint per richiesta: la lista
 * è `GET /manager/cases?requestId=` (righe leggere, senza risposte), il dettaglio `GET /assessments/{id}` e
 * il salvataggio di commento e piano il `PATCH /assessments/{id}`, gli stessi della coda della pagina Avvisi
 * (`LongevityAlertsService`). Qui c'è in più il questionario, dato di riferimento per i testi delle domande.
 */
@Injectable({ providedIn: 'root' })
export class LongevityRequestAssessmentsService {
  private readonly baseUrl = `${environment.baseURL}/longevity-index`;
  private questionnaire$?: Observable<LongevityQuestionnaireDef>;

  constructor(private http: HttpClient, private staffApi: LongevityAlertsService) {}

  /** Tutti i test della richiesta, dal più recente, senza aprirli (aprirli finisce nel log degli accessi). */
  getAssessments(requestId: number): Observable<LongevityTestRow[]> {
    return this.staffApi.findTestsOfRequest(requestId);
  }

  getAssessmentDetail(submissionKey: string): Observable<LongevityAssessmentDetail> {
    return this.staffApi.getAssessmentDetail(submissionKey);
  }

  /** Salva commento e piano scritti dall'operatore: risponde con il dettaglio aggiornato. */
  updateAssessmentNotes(
    submissionKey: string,
    notes: Required<Pick<LongevityAssessmentUpdate, 'comment' | 'plan'>>
  ): Observable<LongevityAssessmentDetail> {
    return this.staffApi.updateAssessment(submissionKey, notes);
  }

  /** Dato di riferimento condiviso da tutte le domande: una sola chiamata, tenuta in cache. */
  getQuestionnaire(): Observable<LongevityQuestionnaireDef> {
    if (!this.questionnaire$) {
      this.questionnaire$ = this.http
        .get<unknown>(`${this.baseUrl}/questionnaire`)
        .pipe(map(normalizeQuestionnaire), shareReplay(1));
    }
    return this.questionnaire$;
  }
}
